import classNames from 'classnames'
import { GTM_CLICK_EVENT, useEventTracking } from '../../../../helpers/gtmHelper'
import { n_pricing } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation, { useLocaleVars } from '../../../../modules/i18n/useTranslation'
import { useProductContext } from './ProductContext'

const DurationSelector = () => {
  const { t } = useTranslation()
  const { duration_list } = useLocaleVars()
  const { sendClickEvent } = useEventTracking()

  const { purchaseInfo, setPurchaseInfo } = useProductContext()
  const isTwentyActive = duration_list[0]?.value == purchaseInfo.duration?.value

  const handleDurationClick = (duration) => {
    const eventName =
      duration.value == 20 ? GTM_CLICK_EVENT.PURCHASE_PERIOD_20MIN : GTM_CLICK_EVENT.PURCHASE_PERIOD_40MIN
    sendClickEvent({ button_name: eventName })
    setPurchaseInfo((prev) => ({ ...prev, duration }))
  }

  return (
    <div className={`flex gap-[2px] rounded-[5px] bg-gray-100 p-[2px] w-full sm:w-[360px] justify-between`}>
      <button
        className={classNames(
          'Body1-16Bd w-full rounded-[5px] px-[8px] py-[6px] text-center sm:min-w-1/2 whitespace-nowrap',
          {
            'bg-white shadow-[0px_1px_4px_0px_rgba(0,0,0,0.15)] text-black': isTwentyActive,
            'bg-gray-100 text-gray-400': !isTwentyActive,
          }
        )}
        onClick={() => handleDurationClick(duration_list[0])}
      >
        {t(n_pricing.benefit.lesson_20)}
      </button>
      <button
        className={classNames(
          'Body1-16Bd w-full rounded-[5px] px-[8px] py-[6px] text-center sm:min-w-1/2 whitespace-nowrap',
          {
            'bg-white shadow-[0px_1px_4px_0px_rgba(0,0,0,0.15)] text-black': !isTwentyActive,
            'bg-gray-100 text-gray-400': isTwentyActive,
          }
        )}
        onClick={() => handleDurationClick(duration_list[1])}
      >
        {t(n_pricing.benefit.lesson_40)}
      </button>
    </div>
  )
}

export default DurationSelector
